import { message, notification } from 'antd';

const SKIP_KEYS = [
  'success',
  'message',
  'error',
  'homepage_block',
  'homepage_slide',
  'partner',
  'itinerary',
  'landing_page',
  'service',
  'restaurant',
  'footer_menu',
];

const FIELD_ALIASES = {
  title_it: 'title',
  description_it: 'description',
  title: 'title_it',
  description: 'description_it',
};

class ErrorHelper {
  static getErrorsForForm = (data, changedParams = {}) => {
    const errorsData = [];

    Object.entries(data).forEach((i) => {
      errorsData.push({
        name: changedParams[i[0]] || i[0],
        errors: i[1],
      });
    });

    return errorsData;
  };

  static getBackendFieldErrors = (error) => {
    const data = error?.response?.data || {};
    const fieldErrors =
      data.errors &&
      typeof data.errors === 'object' &&
      !Array.isArray(data.errors)
        ? data.errors
        : data;

    if (!fieldErrors || typeof fieldErrors !== 'object') return [];

    const formFields = [];

    Object.entries(fieldErrors).forEach(([rawName, rawErrors]) => {
      if (SKIP_KEYS.includes(rawName)) return;
      if (!Array.isArray(rawErrors) && typeof rawErrors !== 'string') return;

      const name = String(rawName).replace(/^[a-z_]+\./, '');
      const errors = Array.isArray(rawErrors)
        ? rawErrors
        : [String(rawErrors)];

      formFields.push({ name, errors });

      if (FIELD_ALIASES[name]) {
        formFields.push({ name: FIELD_ALIASES[name], errors });
      }
    });

    return formFields;
  };

  static applyToForm = (form, error, fallbackMessage = 'Failed to save') => {
    const formFields = ErrorHelper.getBackendFieldErrors(error);

    if (formFields.length && form) {
      notification.destroy();
      form.setFields(formFields);
      form.scrollToField(formFields[0].name);
      return true;
    }

    const data = error?.response?.data || {};
    message.error(
      data.message || data.error || error?.message || fallbackMessage,
    );
    return false;
  };
}

export default ErrorHelper;
